import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const sections = [
  { id: 'verticals', label: 'Verticals' },
  { id: 'builder', label: 'Builders' },
  { id: 'products', label: 'Auto AI' },
  { id: 'portfolio', label: 'Portfolio' },
];

const LabsNav: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#0A0A0F]/90 backdrop-blur-xl border-b border-[#1F1F2E]/50'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between h-16">
        <button
          onClick={() => navigate('/')}
          className="font-space-grotesk text-sm font-semibold tracking-wide text-white/50 hover:text-white transition-colors"
        >
          Noa Labs
        </button>

        <div className="hidden md:flex items-center gap-8">
          {sections.map((s) => (
            <button
              key={s.id}
              onClick={() => scrollTo(s.id)}
              className="text-[11px] text-white/30 hover:text-white/80 transition-colors tracking-wide uppercase"
            >
              {s.label}
            </button>
          ))}
        </div>

        <a
          href="#footer-cta"
          onClick={(e) => {
            e.preventDefault();
            scrollTo('footer-cta');
          }}
          className="text-[11px] px-5 py-2 rounded-full bg-white/5 border border-white/10 text-white/70 hover:bg-white/10 hover:text-white transition-all font-medium"
        >
          Apply to Build
        </a>
      </div>
    </motion.nav>
  );
};

export default LabsNav;
